import React from 'react';
import { vinculoCurto, vinculoEstilo } from '../utils/vinculo';

// Badge do vínculo empregatício (CLT, PJ, Estágio...) nas listas de admissão e
// rescisão. Quando o vínculo foi presumido pelo cargo — e não lido da Convenia —
// o badge fica tracejado com um '?', para ninguém tratar palpite como cadastro.
const VinculoBadge = ({ vinculo, origem }) => {
  const curto = vinculoCurto(vinculo);
  if (!curto) {
    return <span className="text-muted" title="Sem vínculo no espelho da Convenia">-</span>;
  }
  const e = vinculoEstilo(curto);
  const presumido = origem === 'cargo';
  return (
    <span
      className="badge"
      title={presumido
        ? `${vinculo} — presumido pelo cargo (sem histórico salarial na Convenia)`
        : `${vinculo} — cadastrado na Convenia`}
      style={{
        background: e.bg,
        color: e.cor,
        border: `1px ${presumido ? 'dashed' : 'solid'} ${e.borda}`,
        fontWeight: 600,
        whiteSpace: 'nowrap',
      }}
    >
      {curto}{presumido && <span style={{ opacity: 0.7 }}> ?</span>}
    </span>
  );
};

export default VinculoBadge;
